import { Controller } from "@hotwired/stimulus"
import { blobatar } from "blobatar/blob"

// Turns a stored seed into the SVG blobatar. The wrapper is server-rendered so
// every surface (sidebar, mentions, comments, settings) shares one markup; this
// controller is the only place the library is called. `background: "circle"`
// The circle background matches the round initials badge this replaced.
export default class extends Controller {
  static values = { seed: String }

  seedValueChanged() {
    if (!this.seedValue) return

    this.element.innerHTML = blobatar(this.seedValue, { background: "circle" })
  }
}
